import { ReactElement } from "react";
import LoadingOverlay from "../../_core/components/LoadingOverlay";
import NotAuthorized from "../../_core/components/NotAuthorized";
import { useMonitoringAccess } from "../../monitoring/hooks";

interface MonitoringRouteProps {
  children: ReactElement<any, any> | null;
}

export const MonitoringRoute = ({ children }: MonitoringRouteProps): JSX.Element => {
  const { data: monitoringAccess, isFetching, isError } = useMonitoringAccess();

  if (isFetching) {
    return <LoadingOverlay />;
  }

  if (isError || !monitoringAccess?.hasAccess) {
    return <NotAuthorized />;
  }

  return children || <div />;
};
